import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  content: {
    backgroundColor: 'transparent',
  },
  overlay: {
    backgroundColor: colors.overlayPrimary,
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  body: {
    backgroundColor: colors.backgroundL0,
    position: 'absolute',
    alignSelf: 'center',
    width: '90%',
    top: '45%',
    borderRadius: theme.borderRadius.s,
  },
}));
